/** Portal "Subscribe" picker logic, kept pure so it is unit-tested. */

export type FeedLayout = "all" | "selected" | "per_room";
export type FeedContents = "own" | "all";

export interface IssueTenantCalendarFeedBody {
  name: string;
  room_ids: number[];
  one_per_room: boolean;
  contents: FeedContents;
}

export function buildIssueBody(input: {
  name: string;
  layout: FeedLayout;
  roomIds: number[];
  contents: FeedContents;
}): IssueTenantCalendarFeedBody {
  const trimmed = input.name.trim();
  if (input.layout === "all") {
    return { name: trimmed || "Untitled feed", room_ids: [], one_per_room: false, contents: input.contents };
  }
  const roomIds = [...new Set(input.roomIds)];
  if (input.layout === "per_room") {
    // The server names each feed "<name> · <room>" (or just the room).
    return { name: trimmed, room_ids: roomIds, one_per_room: true, contents: input.contents };
  }
  return { name: trimmed || "Untitled feed", room_ids: roomIds, one_per_room: false, contents: input.contents };
}

export function canIssue(layout: FeedLayout, roomIds: number[]): boolean {
  return layout === "all" || roomIds.length > 0;
}

export function describeFeed(feed: {
  rooms?: { id: number; name: string }[] | null;
  contents?: FeedContents | null;
}): string {
  // Tolerate a stale-tab / pre-rooms backend whose feed rows don't carry
  // ``rooms`` / ``contents`` at all.
  const rooms = feed.rooms ?? [];
  const contents = feed.contents ?? "own";
  const where = rooms.length === 0 ? "All rooms" : rooms.map((r) => r.name).join(", ");
  const what = contents === "all" ? "all bookings" : "our bookings";
  return `${where} · ${what}`;
}
